import * as React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { getImage } from '@utils/imageHelper';
import P2 from '@base/P2/P2';
import Button from '@base/Button/Button';
import Paper from '@base/Paper/Paper';
import { breakpoints } from '@styles/index';
import H5 from '@base/H5/H5';

const Results = styled(Paper)`
  padding: 20px 44px;
  margin-top: 32px;
  background: url(${getImage('practice-session/topics/new.svg')}) no-repeat top
      left,
    var(--color-base-1);
  background-size: 82px 82px;
  display: flex;
  justify-content: space-between;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    margin-top: 24px;
    flex-direction: column;
    background-image: none;
    padding: 16px;
  }
`;

const Notes = styled.img`
  user-select: none;
`;

const Block = styled.div`
  margin-left: 18px;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    margin-bottom: 16px;
  }
`;

const ResultTitle = styled(H5)`
  font-weight: 600;
  color: var(--color-text-primary);
`;

const ResultSubTitle = styled(P2)`
  color: var(--color-text-primary);
`;

const ResultCover = styled.div`
  display: flex;
  align-items: center;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    align-items: flex-start;
  }
`;

const PracticeAgain = styled(Button)`
  min-height: 40px;
  height: 40px;
  width: 142px;
  font-size: 14px;
  border: 1px solid var(--color-divider);
  @media only screen and (max-width: ${breakpoints.mobile}) {
    width: 100%;
  }
`;

const TestResults = ({ result, practiceAgain }) => (
  <Results>
    <ResultCover>
      <Notes
        src={getImage('practice-session/topics/notes.svg')}
        alt="notes"
        width="48"
        height="48"
      />
      <Block>
        <ResultTitle>Practice complete</ResultTitle>
        <ResultSubTitle>{`${result} correct answers`}</ResultSubTitle>
      </Block>
    </ResultCover>
    <PracticeAgain
      label="Practice again"
      variant="hollow"
      color="black"
      onClick={practiceAgain}
    />
  </Results>
);

TestResults.propTypes = {
  result: PropTypes.string.isRequired,
  practiceAgain: PropTypes.func.isRequired
};

export default TestResults;
